var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$store.state.env.isMobile)?_c('WorksDetailsMain',{staticClass:"form-wrap"}):_c('WorksDetailsMainMobile')}
var staticRenderFns = []

export { render, staticRenderFns }